import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EndorsementStatusForm from '../../../components/forms/EndorsementStatusForm';
import { useCreateEndorsementStatus } from '../../../hooks/useEndorsementStatusApi';
import { useNavigate } from 'react-router-dom';
import { EndorsementStatusDTO } from '../../../services/apiClient';

const EndorsementStatusCreate: React.FC = () => {
  const createMutation = useCreateEndorsementStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Endorsement Statuses', href: '/admin/endorsementstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EndorsementStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/endorsementstatuses');
    } catch (error) {
      console.error('Error creating EndorsementStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/endorsementstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EndorsementStatus.Edit"
    >
        <EndorsementStatusForm
          initialValues={{} as EndorsementStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/endorsementstatuses')}
        />
    </AdminLayout>
  );
};

export default EndorsementStatusCreate;
